import { render, staticRenderFns } from "./FullScreenMenu.vue?vue&type=template&id=54b4fc40&scoped=true"
import script from "./FullScreenMenu.vue?vue&type=script&lang=js"
export * from "./FullScreenMenu.vue?vue&type=script&lang=js"
import style0 from "./FullScreenMenu.vue?vue&type=style&index=0&id=54b4fc40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b4fc40",
  null
  
)

export default component.exports